import React from 'react';
import './Carousel.css';

const Carousel = ({ services, direction = 'right', delay = '0s', startIndex = 0 }) => {
  const servicesToRender = direction === 'left' ? [...services].reverse() : services;

  // Rotate the services list so different rows start on different items
  const len = servicesToRender.length;
  const k = ((startIndex % len) + len) % len;
  const rotated = [...servicesToRender.slice(k), ...servicesToRender.slice(0, k)];

  const duplicatedServices = [...rotated, ...rotated];

  return (
    <div className="carousel-container">
      <div className={`carousel-track ${direction}`} style={{ animationDelay: delay }}>
        {duplicatedServices.map((service, index) => (
          <div className="grid-item" key={index}>
            <img src={service.image} alt={service.name} className="grid-image" />
            <img src={service.icon} alt={`${service.name} icon`} className="service-icon" /> {/* New icon element */}
            <div className="grid-item-strip">
              <p className="service-name">{service.name}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Carousel;
